import React from 'react'
import { Button, Modal, ModalBody, Col, Form, Input, CardBody, Media } from 'reactstrap';
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";


export const ModalSendEmail = (props) => {

    const { modalEmail, toggleEmail, email, handleInputChange, saveEmail, validacionesEmail, loading, closeModalEmailCompanies } = props;


    const {
        email_valid
    } = validacionesEmail;

    const footer = (
        <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>

            <Button disabled={loading ? true : false} color="secondary text-center" onClick={() => saveEmail()} type="button" >{"Enviar"}</Button>

            <Button disabled={loading ? true : false} color="danger text-center" onClick={toggleEmail} type="button" >{"Cancelar"}</Button>

        </div>
    );


    return (
        <Dialog
            visible={modalEmail}

            onHide={closeModalEmailCompanies}
            modal
            closable={false}

            dismissableMask={false}
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="fa fa-envelope"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                Envío de accesos a micrositio

                            </div>
                        </div>
                    </div>
                </div>
            }
            className="Global-dialog Global-blue Global-small-v"
            maskClassName="custom-total-mask"
            footer={footer}

        >
            <div className="p-fluid pt-2">
                <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                    <img
                        src={require("../../assets/images/loginHelenLabs/User/email.svg")}
                        alt=""
                        style={{
                            width: "80px",
                            height: "80px",
                            borderRadius: "50%",
                        }}
                    />

                    <div>
                        <h6 className="font-primary f-w-600">
                            Envío de accesos a micrositio
                        </h6>

                        <span className="d-block f-14 pt-3">
                            En caso de requerir más de un correo separarlos con
                            <span className="txt-secondary"> , </span>
                        </span>
                    </div>
                </div>

                <div style={{ marginTop: "20px" }}>
                    <InputTextarea
                        name="email"
                        value={email}
                        autoComplete="nope"
                        onChange={handleInputChange}
                        placeholder="Correo(s)"
                        className="w-full"
                        rows={2}
                        style={{ resize: "none" }}
                        invalid={email_valid}
                        required={true}

                    />

                    {email_valid && (
                        <small className="p-error" style={{ fontSize: "12px" }}>
                            Ingresa un correo
                        </small>
                    )}

                </div>
            </div>
        </Dialog>
    )
}
